<template>
  <div class="md-layout report">
    <h3 v-if="destination" :class="{space: $route.name == 'View Report'}" class="head">
      Report for {{destination.name}}
      <span
        v-if="$route.name != 'View Report'"
        @click="shareLink()"
        class="share"
      >get shareable link</span>
    </h3>
    <div class="filters md-layout-item md-size-100">
      <md-card class="stat">
        <div class="filter">
          <label>Start Date</label>
          <md-datepicker
            :md-disabled-dates="disabledDates"
            class="filter-date"
            v-model="startDate"
          />
        </div>
        <div class="filter">
          <label>End Date</label>
          <md-datepicker :md-disabled-dates="disabledDates" class="filter-date" v-model="endDate" />
        </div>
        <!-- <div class="filter" v-if="filter_distance > 13 && filter_distance < 50">
          <label>Show by Days</label>
          <md-switch v-model="filter_choice" value="days"></md-switch>
        </div>
        <div class="filter" v-if="filter_distance > 13">
          <label>Show by Weeks</label>
          <md-switch v-model="filter_choice" value="weeks"></md-switch>
        </div>
        <div class="filter" v-if="filter_distance > 60">
          <label>Show by Months</label>
          <md-switch v-model="filter_choice" value="months"></md-switch>
        </div>-->
        <div class="filter_button">
          <md-button @click="fetchNewAnalytics">Filter</md-button>
        </div>
      </md-card>
    </div>
    <div class="stats-holder">
      <div class="requests md-layout-item md-size-100">
        <md-card class="stat blue">
          <h2>
            {{ total_requests }}
            <span>
              Requests Sent
              <span v-if="chart2_load">loading...</span>
            </span>
          </h2>
        </md-card>
        <md-card class="stat blue">
          <h2>
            {{ total_views }}
            <span>
              Clicks
              <span v-if="chart2_load">loading...</span>
            </span>
          </h2>
        </md-card>

        <md-card class="stat requests_sent">
          <h3>Requests Sent</h3>
          <div class="chart ct-chart1 home-page-clicks"></div>
          <img v-if="chart2_load" class="loader" src="@/assets/img/loader.gif" />
        </md-card>

        <md-card class="stat requests_sent">
          <h3>Page Clicks</h3>
          <div class="chart ct-chart2 home-page-clicks"></div>
          <img v-if="chart2_load" class="loader" src="@/assets/img/loader.gif" />
        </md-card>

        <md-card class="full">
          <h3>All Requests Data</h3>
          <md-card-content>
            <md-table
              md-fixed-header
              :value="queriedData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover"
            >
              <md-table-toolbar>
                <md-field>
                  <label for="kiosks">Per page</label>
                  <md-select v-model="pagination.perPage" name="kiosks">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >{{ item }}</md-option>
                  </md-select>
                </md-field>

                <md-field>
                  <md-button
                    style="margin-bottom : 7px; background-color: rgb(31, 71, 154) !important;"
                    class="md-primary md-round md-small"
                    @click="downloadRequests()"
                  >Download</md-button>
                </md-field>

                <md-field>
                  <md-input
                    type="search"
                    class="mb-3"
                    clearable
                    style="width: 200px"
                    placeholder="Search records"
                    v-model="searchQuery"
                  ></md-input>
                </md-field>
              </md-table-toolbar>

              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Date" md-sort-by="created_at">
                  {{
                  item.created_at | format_date
                  }}
                </md-table-cell>
                <md-table-cell md-label="Name" md-sort-by="created_at">{{ item.name }}</md-table-cell>
                <md-table-cell md-label="Email" md-sort-by="email">{{ item.email}}</md-table-cell>
                <md-table-cell md-label="Phone" md-sort-by="phone">{{ item.phone }}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class>
              <p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></pagination>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions } from "@/config/firebaseInit";
// import AsyncWorldMap from "@/components/WorldMap/AsyncWorldMap.vue";
// import { StatsCard, AnimatedNumber } from "@/components";
import * as queries from "../../helpers/queries.js";
import * as mappers from "../../helpers/mappers.js";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import router from "@/router";

const moment = require("moment-timezone");

export default {
  components: {
    Pagination
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      destination: null,
      chart1_load: true,
      chart2_load: true,
      chart3_load: true,
      startDate: moment(Date.now())
        .subtract(8, "days")
        .format("YYYY-MM-DD"),
      endDate: moment(Date.now())
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      filter_labels: {
        day: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        month: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      },
      filter_distance: 7,
      filter_choice: [],
      total_requests: null,
      total_views: null,
      category_clicks: null,
      currentSort: "name",
      currentSortOrder: "asc",
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [50, 100, 200, 500],
        total: 0
      },
      footerTable: ["Kiosk", "Description", "Location", "Edit", "Delete"],
      searchQuery: "",
      propsToSearch: ["description", "last_signal", "slug"],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  firestore() {
    return {
      tableData: db
        .collection("contractor")
        .doc(this.$route.params.destination_id)
        .collection("requests")
        .orderBy("created_at", "desc"),
      destination: db
        .collection("contractor")
        .doc(this.$route.params.destination_id)
    };
  },
  mounted() {
    this.$nextTick(async () => {
      let getCategoryClicks = functions.httpsCallable("getAnalytics");
      let categoryClicks = await getCategoryClicks({
        query: queries.getCategoryClicksBetweenTimestamps(
          this.startDate,
          this.endDate
        )
      }).then(res => {
        return res.data;
      });

      this.category_clicks = mappers.categoryClicksMapper(categoryClicks);
      this.chart3_load = false;
      this.createCharts();
    });

    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "url"],
      threshold: 0.3
    });
  },
  methods: {
    createCharts() {
      this.initiateRequestsChart1();
      this.initiateRequestsChart2();
    },
    async initiateRequestsChart1() {
      let getDestinationRequest = functions.httpsCallable("getAnalytics");

      let destinationRequests = await getDestinationRequest({
        query: queries.getDestinationRequestsByIdBetweenTimestamps(
          this.$route.params.destination_id,
          this.startDate,
          this.endDate
        )
      }).then(res => {
        return res.data;
      });

      this.total_requests = destinationRequests.length;

      let data = mappers.destinationRequestMapper(
        destinationRequests,
        this.startDate,
        this.endDate
      );

      let totalXAxis = moment(this.endDate).diff(
        moment(this.startDate),
        "days"
      );

      let skipXAxis = Math.floor(totalXAxis / 7);

      new Chartist.Line(".ct-chart1", data, {
        low: 0,
        showArea: true,
        axisX: {
          labelInterpolationFnc: function(value, i) {
            if ((i + 1) % skipXAxis == 0) return value;
          }
        }
      });
      this.chart2_load = false;
    },
    async initiateRequestsChart2() {
      let getDestinationRequest = functions.httpsCallable("getAnalytics");

      let destinationViews = await getDestinationRequest({
        query: queries.getDestinationViewsByIdBetweenTimestamps(
          this.$route.params.destination_id,
          this.startDate,
          this.endDate
        )
      }).then(res => {
        return res.data;
      });

      this.total_views = destinationViews.length;

      let data = mappers.destinationRequestMapper(
        destinationViews,
        this.startDate,
        this.endDate
      );

      let totalXAxis = moment(this.endDate).diff(
        moment(this.startDate),
        "days"
      );

      let skipXAxis = Math.floor(totalXAxis / 7);

      new Chartist.Line(".ct-chart2", data, {
        low: 0,
        showArea: true,
        axisX: {
          labelInterpolationFnc: function(value, i) {
            if ((i + 1) % skipXAxis == 0) return value;
          }
        }
      });
      this.chart2_load = false;
    },
    disabledDates(date) {
      if (moment(date).isAfter(moment(Date.now()))) return true;
      else return false;
    },
    goTo(url) {
      this.$router.push({ path: "/" + url });
    },
    isOffline(k) {
      if (!k.lastSignal) {
        return true;
      } else {
        const now = moment.tz(Date.now(), "America/New_York");
        const then = moment.tz(k.lastSignal, "America/New_York");
        const duration = moment.duration(now.diff(then));
        const mins = duration.asMinutes();
        // console.log(k.name +': '+mins)
        if (mins > 20) {
          return true;
        } else {
          return false;
        }
      }
    },
    fetchNewAnalytics() {
      this.chart1_load = this.chart2_load = this.chart3_load = true;
      let charts = document.getElementsByClassName("chart");
      for (var i = 0; i < charts.length; i++) {
        charts[i].children[0].remove();
      }
      this.category_clicks = [];
      this.$nextTick(async () => {
        let getCategoryClicks = functions.httpsCallable("getAnalytics");
        let categoryClicks = await getCategoryClicks({
          query: queries.getCategoryClicksBetweenTimestamps(
            this.startDate,
            this.endDate
          )
        }).then(res => {
          return res.data;
        });
        this.category_clicks = mappers.categoryClicksMapper(categoryClicks);
        this.chart3_load = false;
        this.createCharts();
      });
    },
    shareLink() {
      window.open(
        "https://admin-ltg.web.app/reportview/" +
          this.$route.params.destination_id,
        "_blank"
      );
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (
          (this.currentSort === "created_at") &
          (this.currentSortOrder === "desc")
        ) {
          return a[sortBy] - b[sortBy];
        }

        if (
          (this.currentSort === "created_at") &
          (this.currentSortOrder === "asc")
        ) {
          return b[sortBy] - a[sortBy];
        }
        let validateA = a[sortBy] ? a[sortBy] : "";
        let validateB = b[sortBy] ? a[sortBy] : "";
        if (this.currentSortOrder === "desc") {
          return validateA.localeCompare(validateB);
        }
        return validateB.localeCompare(validateA);
      });
    },
    formateCsvData() {
      let data;
      data = this.queriedData.map(request => ({
        Created: moment(request.created_at).format("MM/DD/YYYY"),
        Email: request.email,
        Name: request.name,
        Phone: request.phone
      }));
      return data;
    },
    downloadRequests() {
      let vm = this;
      let requests = this.formateCsvData();

      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(requests[0]).join(";"),
        ...requests.map(item => Object.values(item).join(";"))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "Requests.csv");
      link.click();
    }
  },
  watch: {
    startDate() {
      const start = moment(this.startDate);
      const end = moment(this.endDate);
      this.filter_distance = end.diff(start, "days");
    },
    endDate() {
      const start = moment(this.startDate);
      const end = moment(this.endDate);
      this.filter_distance = end.diff(start, "days");
    },
    filter_choice() {
      if (this.filter_choice.length > 1) this.filter_choice.shift();
    },
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style type="text/css">
.img-card {
  height: 48vh;
  min-height: 300px;
  background-size: cover;
  position: relative;
  border: 10px solid #f5f4f2;
}

.img-card .dark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
}
.img-card .contain {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  height: 100%;
  padding: 30px;
}

.img-card h2 {
  color: white;
  font-size: 20px;
  margin: 0;
  font-weight: bold;
}

.img-card h1 {
  color: white;
  margin: 0;
  font-size: 100px;
}

.img-card h1 span {
  font-size: 20px;
  margin-left: -20px;
}

.stats-holder {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 10px;
}

.stat {
  padding: 30px;
  box-sizing: border-box;
  padding-bottom: 10px;
}

@media screen and (max-width: 500px) {
  .stat {
    padding: 10px;
  }

  .stat h3 {
    padding: 0 20px;
    margin-top: 20px;
  }

  .stat .legend {
    padding: 0 20px;
  }
}

.stat h3 {
  margin: 0;
  font-weight: bold;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.stat h3 span.cta {
  margin-left: 30px;
  color: #3581ef;
  font-size: 15px;
  cursor: pointer;
  font-weight: normal;
  transition: color 0.3s;
}

.stat h3 span.cta:hover {
  color: #134b9d;
}

.home-page-clicks .ct-series-a .ct-bar {
  stroke: #3581ef;
}

.home-page-clicks .ct-series-b .ct-bar {
  stroke: #f44336;
}

.ct-bar {
  stroke-width: 5px;
}

.legend {
  display: flex;
  flex-direction: column;
}

.legend .key {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.legend .key .color {
  height: 10px;
  width: 10px;
  margin-right: 7px;
}

.legend .key p {
  margin: 0;
}

.chart {
  margin-top: 30px;
}

.chart1 {
  height: 100%;
  margin: 0 !important;
}

.ct-chart1 {
  height: 250px;
}

.chart .ct-series-a .ct-area {
  fill: rgba(53, 129, 239, 0.28);
}

.chart .ct-series-a .ct-point,
.ct-series-a .ct-line {
  stroke: #3581ef;
}

.blue {
  background: #3581ef !important;
}

.requests {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.report .requests .md-card {
  width: 49%;
}

.report .requests .md-card.full {
  width: 100%;
}

.md-card.blue {
  padding: 20px 30px;
  margin-bottom: 15px !important;
}

.md-card.blue h2 {
  color: white;
  margin: 0;
}

.md-card.blue h2 span {
  font-size: 20px;
}

.category-clicks {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 150px;
}

@media screen and (max-width: 800px) {
  .stats-holder {
    flex-wrap: nowrap;
    flex-direction: column;
  }

  .main-categories {
    margin-bottom: 15px;
  }

  .stats-holder .md-layout-item {
    width: 100% !important;
    max-width: 100% !important;
  }
}

.category-clicks .category-click {
  width: 200px;
  margin-right: 20px;
}

.category-clicks .category-click p {
  display: flex;
  flex-direction: column;
}

.category-clicks .category-click p span.num {
  color: #3581ef;
  font-weight: bold;
  font-size: 20px;
}

.category-clicks .category-click p span.num span {
  font-size: 14px;
  font-weight: normal;
  margin-left: 0;
}

.filters {
  margin: 0 !important;
  margin-bottom: 15px !important;
}

.filters .md-card {
  margin-bottom: 0 !important;
}

.filter-date {
  max-width: 160px;
  overflow: hidden;
  background: #f7f7f7;
  padding-bottom: 0;
}

.filter-date input {
  margin-left: 0 !important;
}

.filters .stat {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  flex-direction: row;
}

.filters .stat .filter {
  margin-right: 20px;
}

.md-datepicker-dialog .md-datepicker-header {
  background: #134b9d !important;
}

.md-datepicker-body-header .md-button.md-theme-default,
.md-datepicker-body-content .md-button.md-theme-default {
  background: #f7f7f7 !important;
}

.md-datepicker-dialog.md-theme-default
  .md-datepicker-day-button.md-datepicker-selected,
.md-datepicker-selected {
  background: #3581ef !important;
}

.md-datepicker-today {
  background-color: rgba(53, 129, 239, 0.28) !important;
  color: black !important;
}

.filter_button {
  padding: 20px;
}

.requests_sent.md-card {
  min-height: 250px;
  width: 100% !important;
  margin-bottom: 15px !important;
}

.stat .loader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
}

.ct-chart-bar .ct-label.ct-horizontal.ct-end,
.ct-label.ct-horizontal.ct-end {
  padding-top: 7px;
}

.ct-chart2 .ct-label.ct-horizontal.ct-end {
  transform: translateX(-50%);
  text-align: center;
  justify-content: center;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-end::before,
.ct-label.ct-horizontal.ct-end::before {
  content: "";
  position: absolute;
  left: 50%;
  height: 2px;
  transform: translateX(-50%);
  width: 10px;
  background: #d5d5d5;
  top: 0;
}

.ct-chart1 .ct-series-a .ct-area {
  fill: rgba(53, 129, 239, 0.28) !important;
}

.ct-chart1 .ct-series-a .ct-point {
  stroke: #3581ef !important;
}

h3 {
  font-weight: bold;
  padding: 0 !important;
  margin: 0;
}

h3.head {
  padding-left: 20px !important;
}

h3.space {
  padding-top: 30px !important;
}

.share {
  color: #3581ef;
  font-size: 16px;
  margin-left: 20px;
  cursor: pointer;
  text-decoration: underline;
}

.report .requests .md-card.full h3 {
  padding: 20px !important;
  padding-bottom: 0 !important;
}
</style>
